import { Grid } from '@mui/material';
import * as React from 'react';
import { ModuleTypes, Categories } from '../../Module/_config/ModuleInfo';
import ModuleUIInfo, { ModuleUIInfoSettingTypes, ModuleUIInfoSetting } from '../../Module/_config/ModuleUIInfo';
import ModuleCreatorModuleContainer from '../_containers/ModuleCreatorModuleContainer';
import { Trans } from 'react-i18next';

export type Props = {
	opened?: boolean
	category?: string
}

const T = ({children, ...otherProps}:any) => <Trans ns="create" {...otherProps}>{children}</Trans>

export default class ModuleCreator extends React.Component<Props> {
	isVisible(category:Categories, hidden:boolean){
		if (hidden) return false;
		return (this.props.category == category)
	}

	render() {
		return this.props.opened && <div className="module-creator" >
			{ModuleUIInfoSetting && Object.keys(ModuleUIInfoSetting).map((key, i) => {
				let borderClass = ModuleUIInfoSetting[key as ModuleUIInfoSettingTypes].category == Categories.Images ? " with-border" : "";
				return (
					this.isVisible(ModuleUIInfoSetting[key as ModuleUIInfoSettingTypes].category, false) ?
					<Grid item className={"module-cell " + borderClass} md={4} sm={6} xs={12} key={i}>
						<ModuleCreatorModuleContainer
							className="modal-close"
							name={ModuleUIInfoSetting[key as ModuleUIInfoSettingTypes].name}
							icon={ModuleUIInfoSetting[key as ModuleUIInfoSettingTypes].icon}
							category={ModuleUIInfoSetting[key as ModuleUIInfoSettingTypes].category}
							value={ModuleUIInfoSetting[key as ModuleUIInfoSettingTypes].value}
							type={ModuleUIInfoSetting[key as ModuleUIInfoSettingTypes].type}
						/>
					</Grid> : null
				)
			})}
			{ModuleUIInfo && Object.keys(ModuleUIInfo).map((key, i) => {
				let borderClass = ModuleUIInfo[key as ModuleTypes].category == Categories.Images ? " with-border" : "";
				return (
					this.isVisible(ModuleUIInfo[key as ModuleTypes].category, ModuleUIInfo[key as ModuleTypes].isHidden) ?
					<Grid item className={"module-cell " + borderClass} md={4} sm={6} xs={12} key={i}>
						<ModuleCreatorModuleContainer
							className="modal-close"
							name={ModuleUIInfo[key as ModuleTypes].name}
							type={ModuleUIInfo[key as ModuleTypes].type}
							icon={ModuleUIInfo[key as ModuleTypes].icon}
							category={ModuleUIInfo[key as ModuleTypes].category}
							subTitle={ModuleUIInfo[key as ModuleTypes].subTitle}
						/>
					</Grid> : null
				)
			})}
		</div>
	}
}